export default __webpack_public_path__ + "static/media/stonewalls.135e4002.png";